import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';

import {awsConfig} from '../../shared/config';
import {setBucket, addToBucket} from './ActionCreatorsBucket';
import {fetchAuthzs} from './ActionCreatorsAuthorizations';
import * as AuthC from '../../utils/auth/AuthCognito';
import {getAuthorizedWorksitesForEmployer} from '../../utils/auth/Security';
import {ContractMuncaStatus} from '../../components/constants/Consts';

export const fetchEmployees = (employerId) => (dispatch) => {
    dispatch(employeesLoading({employerId: employerId}));

    const urlParams = new URLSearchParams({ employerId: employerId });
    const authzWorksites = getAuthorizedWorksitesForEmployer(employerId);
    if(authzWorksites) {
        urlParams.append("wslist", authzWorksites);
    }
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYEES}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(employees => dispatch(addEmployees(employees)))
        .catch(error => {
            dispatch(employeesFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Angajatorilor" } }));
        });
}

const employeesLoading = (loadCriteria) => ({
    type: ActionTypes.EMPLOYEES_LOADING,
    payload: loadCriteria
});

const employeesFailed = (errmess) => ({
    type: ActionTypes.EMPLOYEES_FAILED,
    payload: errmess
});

export const resetEmployeesError = () => ({
    type: ActionTypes.RESET_EMPLOYEES_ERROR
});


const addEmployees = (employers) => ({
    type: ActionTypes.ADD_EMPLOYEES,
    payload: employers
});


export const postEmployee = (employee) => (dispatch) => {
    employee.createDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYEES, {
        method: "POST",
        body: JSON.stringify(employee),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(employee => dispatch(addEmployee(employee)))
        .then(employeeAction => dispatch(setBucket({ mostRecentEmployeeId: employeeAction.payload.id, snackbar: { open: true, severity: "success", message: "Angajatul creat cu succes" } })))
        .catch(error => {
            dispatch(employeesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Angajat" } }));
        });
}

const addEmployee = (employee) => ({
    type: ActionTypes.ADD_EMPLOYEE,
    payload: employee
});
  

export const patchEmployee = (employee) => (dispatch) => {
    employee.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYEES + `/${employee.id}`, {
        method: "PATCH",
        body: JSON.stringify(employee),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(employee => {
            if(employee.employmentDetails.contractStatus === ContractMuncaStatus.Inchis) {
                dispatch(fetchAuthzs(employee.id));
            }
            return dispatch(updateEmployee(employee))
        })
        .then(empAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Angajat actualizate cu succes" } })))
        .catch(error => {
            dispatch(employeesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii datelor Angajat" } }));
        });
}


const updateEmployee = (employee) => ({
    type: ActionTypes.UPDATE_EMPLOYEE,
    payload: employee
});


export const deleteEmployee = (employeeId, employerId) => (dispatch) => {

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    const urlParams = new URLSearchParams({ employerId: employerId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYEES}/${employeeId}?${urlParams}`);

    return fetch(url.href, {
        method: "DELETE",
        body: JSON.stringify({}),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(() => dispatch(removeEmployee(employeeId)))
        .then(empAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Angajat sterse cu succes" } })))
        .catch(error => {
            dispatch(employeesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul stergerii Angajat" } }));
        });
}

const removeEmployee = (employeeId) => ({
    type: ActionTypes.DELETE_EMPLOYEE,
    payload: employeeId
});


